/** Writes one vec4 into `target` at vec4 index `slot`, with no array literal per write. */
export function writeVec4(target, slot, x, y, z, w = 0) {
    const offset = slot * 4;
    target[offset] = x;
    target[offset + 1] = y;
    target[offset + 2] = z;
    target[offset + 3] = w;
}
//# sourceMappingURL=writeVec4.js.map